import React, { useEffect, useState } from 'react'
import './CatalogPageCard.scss'
import formatDateToDelivery from '../functions/formatDateToDelivery'

import { ReactComponent as DeliveryIcon } from '../../components/assets/CatalogPage/DeliveryCatalogPageCard.svg'
import { ReactComponent as CartIcon } from '../../components/assets/CatalogPage/CartCatalogPageHead.svg'
import useFindItemByUnit from '../../../hooks/useFindItemByUnit'
import useFindInCart from '../../../hooks/useFindInCart'
import { useDispatch } from 'react-redux'
import { setAllItemsCart, setCartElemQuantityValue } from '../../../store/slices/allItemsCart'
import { useParams } from 'react-router'
import { catalogs } from '../../../constants/catalogs'


const CatalogPageCard = ({ view = 'grid', item = {} }) => {
  const inCart = useFindInCart(item)
  const dispatch = useDispatch()
  
  const platform = useParams().platform
  const catalogPresonal = catalogs?.find((el) => el?.link === platform)

  // STATES
  const [localQuantity, setLocalQuantity] = useState(inCart ? inCart.quantity : 1)

  // USEEFFECT
  useEffect(() => {
    if (inCart) {
      setLocalQuantity(inCart.quantity)
    } else {
      setLocalQuantity(1) // Сброс на 1, если удалили из корзины
    }
  }, [inCart])

  //HANDLERS
  const handleQuantityChange = (e) => {
    const val = parseFloat(e.target.value)
    setLocalQuantity(val)

    if (inCart) {
      dispatch(
        setCartElemQuantityValue({
          sku: item.sku,
          value: val,
          elem: item,
        }),
      )
    }
  }

  const handleCartClick = () => {
    // Формируем объект для отправки.
    // Важно: передаем localQuantity как quantity и quantityOrder
    const payload = {
      ...item,
      quantity: localQuantity > 0 ? localQuantity : 1,
      quantityOrder: localQuantity > 0 ? localQuantity : 1,
    }

    dispatch(setAllItemsCart(payload))
  }


  return view == 'grid' ? (
    item ? (
      <div className='CatalogPageCardGrid'>
        <div className='imgBox'>
          <img src={item?.img} alt={item?.name} />
        </div>
        <div className='Name'>{item?.name}</div>
        <div className='Package'>
          <p className='Package__text'>Packaging:</p>
          <span className='Package__qt'>
            {item?.minQt} {item?.currentUnit}
          </span>
        </div>
        <div className='Delivery'>
          <DeliveryIcon /> {item?.date && formatDateToDelivery(item?.date)}
        </div>
        <div className='Price'>
          <span className='Price__withoutVat'>
            €{(item?.initialPrice * useFindItemByUnit(item, inCart?.currentUnit || item?.unit?.split(',')[0]) * 1)?.toFixed(2)}
          </span>
          <p className='Price__withVat'>
            IVA/IGIC Incl. €
            {((item?.spoPrice * (useFindItemByUnit(item, inCart?.currentUnit || item?.unit?.split(',')[0]) * 1)) / (1 + item.IVA / 100))?.toFixed(2)}
          </p>
        </div>
        <div className='Counter'>
          <input type='number' value={localQuantity} onChange={handleQuantityChange} placeholder='0' min='0' max='1000' className='Counter__input' />

          <button className='Counter__btn' onClick={handleCartClick}
            style={catalogPresonal ? { background: catalogPresonal?.color } : { }}
          >
            <CartIcon width={16} height={16} />
            {inCart && inCart.quantity > 0 && <span className='Counter__btn__quantity'>{inCart?.quantity}</span>}
          </button>
        </div>
      </div>
    ) : (
      <div className='CatalogPageCardGrid'>
        <div className='imgBox skeleton'></div>
        <div className='Name skeleton'></div>
        <div className='Package skeleton'>
          <p className='Package__text'></p>
        </div>
        <div className='Delivery skeleton'></div>
        <div className='Price skeleton'>
          <span className='Price__withoutVat skeleton'></span>
          <p className='Price__withVat skeleton'></p>
        </div>
        <div className='Counter'>
          <input type='number' className='Counter__input skeleton' />

          <button className='Counter__btn skeleton' style={{ background: '#eee' }}></button>
        </div>
      </div>
    )
  ) : item ? (
    <div className='CatalogPageCardLine'>
      <div className='imgBox'>
        <img src={item?.img} alt={item?.name} />
      </div>
      <div className='CatalogPageCardLine__content'>
        <div className='Name'>{item?.name}</div>
        <div className='Package'>
          <p className='Package__text'>Packaging:</p>
          <span className='Package__qt'>
            {item?.minQt} {item?.currentUnit}
          </span>
          
        </div>
        <div className='Delivery'>
          <DeliveryIcon /> {item?.date && formatDateToDelivery(item?.date)}
        </div>
        <div className='rw'>
          <div className='Price'>
            <span className='Price__withoutVat'>
              €{(item?.initialPrice * useFindItemByUnit(item, inCart?.currentUnit || item?.unit?.split(',')[0]) * 1)?.toFixed(2)}
            </span>
            <p className='Price__withVat'>
              IVA/IGIC Incl. €
              {((item?.spoPrice * (useFindItemByUnit(item, inCart?.currentUnit || item?.unit?.split(',')[0]) * 1)) / (1 + item.IVA / 100))?.toFixed(
                2,
              )}
            </p>
          </div>
          <button className='Counter__btn' onClick={handleCartClick}
            style={catalogPresonal ? { background: catalogPresonal?.color } : { }}
          >
            <CartIcon width={16} height={16} />
            {inCart && inCart.quantity > 0 && <span className='Counter__btn__quantity'>{inCart?.quantity}</span>}
          </button>
        </div>
      </div>
    </div>
  ) : (
    <div className='CatalogPageCardLine'>
      <div className='imgBox skeleton'></div>
      <div className='CatalogPageCardLine__content'>
        <div className='Name skeleton'></div>
        <div className='Package skeleton'>
          <p className='Package__text'></p>
        </div>
        <div className='Delivery skeleton'></div>
        <div className='rw'>
          <div className='Price skeleton'>
            <span className='Price__withoutVat'></span>
            <p className='Price__withVat skeleton'></p>
          </div>
          <button className='Counter__btn skeleton' style={{ background: '#eee' }}></button>
        </div>
      </div>
    </div>
  )
}

export default CatalogPageCard
